export default __webpack_public_path__ + "static/media/msdss.4693f1c1.jpg";